<script setup>
  defineProps({
    product: Object,
    variant: { type: Object, required: false },
    brand: Object,
    category: Object,
  });
</script>
<template>
  <div class="meta-data">
    <div class="info-wrapper">
      <div v-if="brand" class="info brand">
        <span class="property">{{ $t('Marka') + ':' }}</span>
        <VisitorLink class="value" :href="route('web.product.index', { brands: [brand.id] })">
          {{ brand.name }}
        </VisitorLink>
      </div>
      <div v-if="category" class="info category">
        <span class="property">{{ $t('Kategoria') + ':' }}</span>
        <VisitorLink class="value" :href="route('web.product.category', { category })">
          {{ category.title }}
        </VisitorLink>
      </div>
      <div v-if="variant?.ean || product.ean" class="info ean">
        <span class="property">{{ $t('EAN') + ':' }}</span>
        <span class="value">{{ variant?.ean || product.ean }}</span>
      </div>
      <div v-if="variant?.sku || product.sku" class="info sku">
        <span class="property">{{ $t('SKU') + ':' }}</span>
        <span class="value">{{ variant?.sku || product.sku }}</span>
      </div>
      <div v-if="variant?.mpn || product.mpn" class="info mpn">
        <span class="property">{{ $t('MPN') + ':' }}</span>
        <span class="value">{{ variant?.mpn || product.mpn }}</span>
      </div>
      <div v-if="variant?.manufacturer_catalog_url || product.manufacturer_catalog_url" class="info mcu">
        <span class="property">{{ $t('Katalog producenta') + ':' }}</span>
        <a :href="variant?.manufacturer_catalog_url || product.manufacturer_catalog_url" target="_blank" rel="noopener noreferrer" class="value">
          {{ $t('Zobacz') }}
        </a>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .meta-data {
    .info-wrapper {
      display: flex;
      flex-direction: column;
      row-gap: 0.625rem;

      .info {
        display: flex;
        gap: 0.25rem 0.375rem;
        line-height: 1;
        font-size: 1rem;
        flex-wrap: wrap;
        font-weight: var(--font-weight-500);

        .property {
          display: inline-block;
          z-index: 2;
        }

        a.value {
          transition-property: color;
          transition-duration: var(--transition-primary-duration);
          transition-timing-function: var(--transition-primary-timing-function);
          cursor: pointer;

          &:hover {
            color: var(--primary-color);
          }
        }
      }
    }
  }

  @media(max-width: 992px) {
    .meta-data .info-wrapper .info {
      font-size: 0.75rem;
    }
  }
</style>
